// extracted by mini-css-extract-plugin
export default {"AddOrEditAssessment":"styles_AddOrEditAssessment__LNSAZ","col":"styles_col__LhpAk","buttonContainer":"styles_buttonContainer__QvTR0"};